import ResourceGetter  from '../../../model/resource/getter/resource-getter'
import SessionStorage  from '../../storage/session-storage'
import ConditionHelper from '../../helper/condition-helper'

export default class DataGetter {

  /**
   *
   * @param value
   */
  set id (value) {
    this._id = value
  }

  /**
   *
   * @param value
   */
  set query (value) {
    this._query = value
  }

  /**
   *
   * @param value
   */
  set offset (value) {
    this._offset = value
  }

  /**
   *
   * @param value
   */
  set limit (value) {
    this._limit = value
  }

  /**
   *
   * @param value
   */
  set def (value) {
    this._def = value
  }

  /**
   *
   * @param user
   */
  set user (user) {
    this._user = user
  }

  constructor () {
    this._def    = null
    this._limit  = null
    this._offset = 1
    this._query  = null
    this._id     = null
    this._user   = null
  }

  /**
   *
   * @param success
   * @param error
   */
get (success, error) {
  if (!this._def) {
    throw new Error('Definition must be set!')
  }

  // @TODO: this must be delegate to someone else
  // if (this._query === null) {
  if (!ConditionHelper.isInterpretationTree(this._def.interpretation)) {
    let query   = SessionStorage.getArrayItem(
      SessionStorage.GRID_QUERY, window.location.href)
    this._query = query ? query.text : null
  }

  if (!this._validate()) {
    console.warn('DataGetter validation failed - returning empty data')
    success({ data: [], rowCount: 0 })
    return
  }

  ResourceGetter
    .get(this._def.viewName)
    .setDef(this._def)
    .find(this._prepareArgs())
    .then(response => {
      let data = {
        data:     response.data,
        rowCount: response.data.length ? response.data[0].ROWS_COUNT : 0
      }

      success(data)
    })
    .catch(e => {
      error(e)
    })
}

  /**
   *
   * @return {{limit: null, offset: null}}
   * @private
   */
  _prepareArgs () {
    return {
      limit:          this._limit,
      offset:         this._offset,
      idtEntity:      this._def.idtEStrctr,
      whereCondition: this._prepareRestrictions(),
      searchText:     this._query,
      orderBy:        this._def.orderBy,
    }
  }

  /**
   *
   * @private
   */
  _prepareRestrictions () {
    let whereCondition = this._def.whereCondition

    if (whereCondition && whereCondition.includes('%ID%')) {
      return whereCondition.replace('%ID%', this._id)
    }

    if (whereCondition && whereCondition.includes('@IDLOGUSER')) {
      return whereCondition.replace('@IDLOGUSER', this._user.id)
    }

    return whereCondition
  }

 /**
 *
 * @private
 * @return boolean
 */
_validate () {
  if (this._def.whereCondition
    && this._def.whereCondition.includes('%ID%')
    && !this._id
  ) {
    console.warn(
      'GetPaget request has not valid parameters in def Object!',
      '\nWhereCondition:', this._def.whereCondition,
      '\nID:', this._id,
      '\nDefinition:', this._def
    )
    return false
  }

  return true
}
}
